module.exports = __webpack_public_path__ + "img/md_main_img.477cd008.png";